export default __webpack_public_path__ + "static/pieces-347b3e312c69d9d3eeacbf805383329c.png";